import { render, staticRenderFns } from "./TypistHub.vue?vue&type=template&id=6b13ac25&scoped=true"
import script from "./TypistHub.vue?vue&type=script&lang=js"
export * from "./TypistHub.vue?vue&type=script&lang=js"
import style0 from "./TypistHub.vue?vue&type=style&index=0&id=6b13ac25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13ac25",
  null
  
)

export default component.exports